export default {
  CHANNEL_NOTIFICATION_DETAIL_REQUEST: 'APP/CHANNEL_NOTIFICATION/CHANNEL_NOTIFICATION_LIST_REQUEST',
  CHANNEL_NOTIFICATION_DETAIL_SUCCESS: 'APP/CHANNEL_NOTIFICATION/CHANNEL_NOTIFICATION_LIST_SUCCESS',
  CHANNEL_NOTIFICATION_DETAIL_ERROR: 'APP/CHANNEL_NOTIFICATION/CHANNEL_NOTIFICATION_LIST_ERROR',
};
